import React from "react";
import { AHIcon, Circle } from "arkh";

export function TeamScheduleAdminItemAddIcon() {
  return (
    <Circle
      size="smallMedium"
      style={{ borderWidth: 1 }}
      borderColor="washedText"
    >
      <AHIcon type="add" size="xsmall" color="washedText" />
    </Circle>
  );
}
